import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { Toast, ToastType } from './toaster.service';

import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-toaster',
    templateUrl: './toaster.component.html',
    styleUrls: ['./toaster.component.scss'],
    imports: [MatIcon]
})
export class ToasterComponent {

  toastType = ToastType;
  constructor(@Inject(MAT_SNACK_BAR_DATA) public toast: Toast) { }

}
